module.exports = __webpack_public_path__ + "img/lv.f720a6e.svg";